import { render } from "./AsHeaderMobile.vue?vue&type=template&id=52622dfb&scoped=true&ts=true"
import script from "./AsHeaderMobile.vue?vue&type=script&lang=ts"
export * from "./AsHeaderMobile.vue?vue&type=script&lang=ts"

import "./AsHeaderMobile.vue?vue&type=style&index=0&id=52622dfb&lang=scss"
import "./AsHeaderMobile.vue?vue&type=style&index=1&id=52622dfb&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/5c6defa0/0/anyclass/anyclass-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52622dfb"]])

export default __exports__